import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

// TODO: Get hotel name from redux
const hotelName = '';

const HotelLogo = ({ left = false }) => {
  const hotelInfo = useSelector((state) => state.app.hotelInformation);
  const logo = `${hotelInfo?.logoPrefix},${hotelInfo?.logo}`;

  return (
    <div className={`flex ${left ? 'justify-start' : 'justify-center'}`}>
      <img
        className={`${left ? 'h-28' : 'h-44'}`}
        src={logo}
        alt={`${hotelName} logo`}
      />
    </div>
  );
};

HotelLogo.propTypes = {
  left: PropTypes.bool,
};

export default HotelLogo;
